
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 9.5A1.5 1.5 0 015.5 8h21a1.5 1.5 0 010 3h-21A1.5 1.5 0 014 9.5zM4 16a1.5 1.5 0 011.5-1.5h21a1.5 1.5 0 010 3h-21A1.5 1.5 0 014 16zM4 22.5A1.5 1.5 0 015.5 21h21a1.5 1.5 0 010 3h-21A1.5 1.5 0 014 22.5z","fill":"#000"}})])
          )
        }
      }
    